import { Component, OnInit, Optional, Inject, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { State as MenuState } from '../../../redux/reducers/menu';
import { IMenuClickHandler, MENU_CLICK_HANDLERS, AdaptiveService } from '@uxdf/direct-shared-lib';
import * as rootReducers from '../../../redux/reducers';
import { Router } from '@angular/router';

import { __config_social_links, __config_contact } from '../../../redux/reducers';
import { filter, map } from 'rxjs/operators';
import { Menu } from '../../../redux/models/menu';
import { MenuItemImpl, MenuItem } from './menu-item.model';
import { HeaderDirectComponent } from './header/header-direct.component';
import { HttpService } from '@seco/core';

@Component({
  standalone: false,
  selector: 'app-direct-homepage-layout',
  templateUrl: './homepage-layout.component.html',
  styleUrls: ['./homepage-layout.component.scss']
})
export class HomepageLayoutComponent implements OnInit, AfterViewInit, OnDestroy {
  public menu: Menu;
  public contact$: Observable<{ config: any }>;
  public socials$: Observable<{ config: any }>;
  public topMenu: MenuItem[];
  public bottomMenu: MenuItem[];
  public menuOpen: boolean;
  public showSearchPanel = false;
  public isDesktop: boolean;
  public headerHeight = 0;
  public isAppLoadedForSSO: boolean;

  private readonly subscriptions: Subscription;
  /* eslint-disable */
  @ViewChild(HeaderDirectComponent, { read: ElementRef })
  private readonly header: ElementRef;

  constructor(
    // private http: HttpClient,
    private readonly store: Store<any>,
    // private languageService: LanguageService,
    private readonly adaptiveService: AdaptiveService,
    private readonly httpService: HttpService,
    private readonly route: Router,
    @Optional()
    @Inject(MENU_CLICK_HANDLERS)
    private readonly clickHandlers?: IMenuClickHandler[]
  ) {
    this.subscriptions = new Subscription();
  }

  ngOnInit() {
    this.isAppLoadedForSSO = localStorage.getItem('source')?.toLocaleLowerCase() === 'ash' || localStorage.getItem('source')?.toLocaleLowerCase() === 'snow';
    this.socials$ = this.store.pipe(select(__config_social_links));
    this.contact$ = this.store.pipe(select(__config_contact));

    this.isDesktop = this.adaptiveService.isDesktop();
    this.menuOpen = this.isDesktop;
    this.subscriptions.add(
      this.store
        .pipe(
          select(rootReducers.getMenuListState),
          filter((menu: MenuState) => !menu.isLoading),
          map(menu => menu.menuList)
        )
        .subscribe(menuList => {
          this.menu = menuList;
          this.topMenu = menuList.navigation.map(item => new MenuItemImpl(item, null, this.clickHandlers));
          this.bottomMenu = menuList.footer.map(item => new MenuItemImpl(item, null, this.clickHandlers));
        })
    );
    this.subscriptions.add(
      this.adaptiveService.getResizeEvent().subscribe(_ => {
        this.headerHeight = this.header?.nativeElement.offsetHeight;
        this.isDesktop = this.adaptiveService.isDesktop();
        if (!this.isDesktop) {
          this.menuOpen = false;
        }
      })
    );

    //We clear the AD session for the user when either the ASH user signs-out or when the ASH session expires.
    //Upon receiving the SIGNOUT message from ASH(parent), AD session gets cleared too.
    //We send an event back to ASH(parent) to stop auto-refresh in the case of ASH inactivity.
    window.addEventListener(
      'message',
      event => {
        if (event.data.toString().includes('SIGNOUT')) {
          window.parent.postMessage('OnePortal-Refresh', '*');
          this.httpService.postApfPlus('amadeusdirect', 'logout');
          localStorage.clear();
          sessionStorage.clear();
        }
      },
      false
    );
  }

  ngAfterViewInit() {
    // run after view checked, but only on init
    setTimeout(() => (this.headerHeight = this.header?.nativeElement.offsetHeight));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
